import * as React from "react"

const defaultState = {
  lang: "tr",
}
const SiteContext = React.createContext(defaultState)

export default SiteContext;